import _ from 'lodash';
import { toast } from 'react-toastify';
import {
	observable,
	action,
	computed,
	runInAction
} from 'mobx';

import { BaseStore } from 'common/stores';
import config from 'client/shared/config';

const { routes } = config;

class GenreStore extends BaseStore {
	apiRoute = routes.genres;

	@observable
	searchResults = [];

	@computed
	get data () {
		return {
			genre: this._data.item
		};
	}

	@computed
	get genres () {
		return this._items;
	}

	set genres (genres) {
		this._items = genres;
	}

	@computed
	get options () {
		return this.searchResults
			.map((genre) => _.omit(genre, 'createdAt', 'updatedAt'));
	}

	@computed
	get sortedGenreList () {
		return _(this.genres).sortBy('label').value();
	}

	@action
	async saveGenre ( opts = {}) {//newGenre,
		const { silent = false } = opts;
		const payload = { ...this.data.genre.toPOJO() };

		this.isLoading = silent !== true;

		try {

			const response = await this.saveData(payload, routes.genreCreate);
			toast.success('Genre saved!');
			this.genres.unshift(payload);
		} catch (err) {

			toast.error('Error saving genre!');
			throw err;
		} finally {

			this.isLoading = false;
		}
	}

	@action
	async updateGenre (change, opts = {}) {
		const { _id = null } = change;

		if (_.isNull(_id)) {

			return;
		}

		const { silent = false } = opts;
		const payload = {
			...change,
			type: this.changeTypes.UPDATE
		};

		this.isLoading = silent !== true;

		try {

			const { data: updatedGenre } = await this.saveItem(payload);

			runInAction('Updated with updated genre', () => {
				this._items = this._items.slice().map((genre) => (
					genre._id === _id ? updatedGenre : genre
				));

				toast.success('Genre saved!');
			});
		} catch (err) {

			toast.error('Error saving genre!');
			throw err;
		} finally {

			this.isLoading = false;
		}
	}

	@action
	async saveGenreArtwork (change, opts = {}) {
		const { _id } = change;
		const {
			silent = false,
			onSuccess = () => {}
		} = opts;

		const payload = {
			...change,
			path: `genre-images/${_id}`,
			type: this.changeTypes.UPDATE
		};

		this.isLoading = silent !== true;

		try {

			const updatedGenre = await this.updateItem(payload);

			runInAction('Save Genre Artwork', () => {
				this._items = this._items.slice().map((genre) => {
					return genre._id === _id ? updatedGenre : genre
				});

				toast.success('Genre saved!');
				onSuccess(updatedGenre);
			});
		} catch (err) {

			toast.error('Error saving genre!');
			throw err;
		} finally {

			this.isLoading = false;
		}
	}

	@action
	async addGenres (genres) {
		const data = await this.saveItem(genres);

		runInAction('Save Genre Artwork', () => {
			this.genres = data;
		});
	}

	@action
	async search (search) {
		try {

			const route = routes.searchGenres.replace(/:search/, search);
			const { data } = await this.ax.get(route);

			this.searchResults = data;
		} catch (err) {

			console.log('[FETCH GENRES ERROR]', err);
			return [];
		}
	}

	@action
	setEditGenreRowID (_id) {
		this._editGenreRowID = _id;
	}

	@action
	deleteGenre (genre) {
		this.deleteItem(genre);
		toast.success('Genre deleted!');
	}

	getLabel(_id) {
		const index = this.getItemIndex({ _id });
		const genre = this.genres[index];
		return _.isObject(genre) ? genre.label : '';
	}
}

const artistStore = new GenreStore();
export default artistStore;
